<template>
    <section>
        <p class="title is-1">Agregar usuario</p> 
         <b-breadcrumb
            align="is-left"
        >
            <b-breadcrumb-item tag='router-link' to="/">Inicio</b-breadcrumb-item>
            <b-breadcrumb-item tag='router-link' to="/usuarios">Usuarios</b-breadcrumb-item>
            <b-breadcrumb-item active>Agregar usuario</b-breadcrumb-item>
        </b-breadcrumb>
        <form-usuario @registrar="onRegistrar" :usuario="datosUsuario"/> 
        <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
    </section>
</template>
<script>
    import FormUsuario from './FormUsuario'
    import HttpService from '../../Servicios/HttpService'

    export default{
        name: "AgregarUsuario",
        components: { FormUsuario },

        data:()=>({
            cargando: false,
            datosUsuario: {
                usuario: "",
                nombre: "",
                telefono: ""
            }
        }),

        methods: {
            onRegistrar(usuario) {
                console.log(usuario)
                this.cargando = true
                let payload = {
                    accion: 'registrar',
                        usuario: usuario,
                        roleId: usuario.roleId,
                        grupoId: usuario.grupoId || null
                }

                HttpService.registrar('usuarios.php', payload)
                .then(registrado => {
                    if(registrado) {
                        this.cargando = false
                        this.$buefy.toast.open({
                          type: 'is-info',
                          message: 'Usuario registrado con éxito. Recuerda que la contraseña es PacoHunterDev'
                        })
                        // Si el usuario fue asignado a un grupo, actualizar el jefe del grupo en localStorage
                        try {
                            const gid = usuario.grupoId
                            const raw = localStorage.getItem('grupos')
                            const grupos = raw ? JSON.parse(raw) : []
                            // limpiar cualquier grupo que tuviera este usuario como jefe
                            for (let i = 0; i < grupos.length; i++) {
                                if (grupos[i].jefe === usuario.nombre) grupos[i].jefe = ''
                            }
                            // asignar al grupo elegido
                            if (gid) {
                                const idx = grupos.findIndex(g => Number(g.id) === Number(gid))
                                if (idx !== -1) grupos[idx].jefe = usuario.nombre || grupos[idx].jefe || ''
                            }
                            localStorage.setItem('grupos', JSON.stringify(grupos))
                            window.dispatchEvent(new Event('gruposUpdated'))
                        } catch (e) {
                            console.warn('No se pudo actualizar grupo en localStorage', e)
                        }
                    }
                })
            }   
        }

    }
</script>